<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} grupo
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Transporte <span class="required"></span>
                    <ng-container *ngIf="transportSelected != null">
                      <span class="m-l-15"><i class="fas fa-phone m-r-5"></i>{{transportSelected.cellphone}}</span>
                      <span class="m-l-10 f-s-11">/{{transportSelected.vehicle_type}}</span>
                      <button type="button" class="btn btn-light btn-sm float-right" data-toggle="modal" data-target="#openExtendsRecordTransport" (click)="RecordTransportExtendsComponent.init(transportSelected)">
                        <i class="fas fa-chart-bar"></i> Hist.
                      </button>
                    </ng-container>
                  </label>
                  <ng-container *ngIf="transportSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{transportSelected.owner}}">
                      <div class="input-group-append bg-custom b-0 removeClient" ng-if="transport != null">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          uib-tooltip="Quitar" (click)="removeTransport()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="transportSelected == null">
                    <component-search-transport [classSize]="'search-small'"
                      (selectedTransportEvent)="selectedTransportSearch($event)" class="w-100">
                    </component-search-transport>
                  </ng-container>
                </div>
                <div class="form-group col-lg-2">
                  <label>Tipo Serv. Mov.</label>
                  <select class="form-control" id="typevehicle_tour" formControlName="typevehicle_tour" (change)="changeTypeVehicleTour()">
                    <option [ngValue]="null">Todos</option>
                    <option *ngFor="let item of vehiclestours" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-2">
                  <label>N° Asientos</label>
                  <input type="text" class="form-control bold" [(ngModel)]="capacity"
                    [ngModelOptions]="{standalone: true}" disabled>
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div class="form-group col-lg-4">
                      <label><span class="badge badge-success f-s-12">Selecc.</span></label>
                      <input type="text" class="form-control bold" [(ngModel)]="selected"
                        [ngModelOptions]="{standalone: true}" disabled>
                    </div>
                    <div class="form-group col-lg-4">
                      <label><span class="badge badge-info f-s-12">Disp.</span></label>
                      <input type="text" class="form-control bold" [(ngModel)]="available"
                        [ngModelOptions]="{standalone: true}" disabled>
                    </div>
                    <div class="form-group col-lg-4">
                      <label><span class="badge badge-danger f-s-12">Excd.</span></label>
                      <input type="text" class="form-control bold text-danger" [(ngModel)]="exceeded"
                        [ngModelOptions]="{standalone: true}" disabled>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Guía de viaje <span class="required"></span>
                    <ng-container *ngIf="guideSelected != null">
                      <span class="m-l-15"><i class="fas fa-phone m-r-5"></i>{{guideSelected.cellphone}}</span>
                      <button type="button" class="btn btn-light btn-sm float-right" data-toggle="modal" data-target="#openExtendsRecordGuide" (click)="RecordGuideExtendsComponent.init(guideSelected)">
                        <i class="fas fa-chart-bar"></i> Hist.
                      </button>
                    </ng-container>                    
                  </label>
                  <ng-container *ngIf="guideSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{guideSelected.fullname}}">
                      <div class="input-group-append bg-custom b-0 removeClient" ng-if="transport != null">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          uib-tooltip="Quitar" (click)="removeGuide()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="guideSelected == null">
                    <component-search-guides [classSize]="'search-small'"
                      (selectedGuideEvent)="selectedGuideSearch($event)" class="w-100">
                    </component-search-guides>
                  </ng-container>
                </div>
                <div class="form-group col-lg-2">
                  <label>Fecha salida <span class="required"></span></label>
                  <input type="text" id="date_departure" [(ngModel)]="date_departure"
                    [ngModelOptions]="{standalone: true}" class="form-control" />
                </div>
                <div class="form-group col-lg-2">
                  <label>G.Trabajo <span data-toggle="tooltip" data-placement="right"
                      data-original-title="Solo se listarán únicamente las reservas asociadas al grupo de trabajo seleccionado"><i
                        class="fas fa-info-circle f-s-14"></i></span>
                  </label>
                  <select class="form-control" id="workinggroup_id" formControlName="workinggroup_id">
                    <option value="null">Todos</option>
                    <option *ngFor="let item of workinggroups" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Destino turístico <span class="required"></span></label>
                  <ng-container *ngIf="tourSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{tourSelected.description}}">
                      <ng-container *ngIf="!isEdit">
                        <div class="input-group-append bg-custom b-0 removeClient" ng-if="transport != null">
                          <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                            uib-tooltip="Quitar" (click)="removeTour()">
                            <i class="fas fa-backspace w-100 f-s-12"></i>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="tourSelected == null">
                    <component-search-tour [classSize]="'search-small'" (selectedTourEvent)="selectedTourSearch($event)"
                      class="w-100"></component-search-tour>
                  </ng-container>
                  <!-- <div class="input-group input-group-grid">
                    <div angucomplete-alt id="search_tour" placeholder="Buscar tour" pause="500"
                      selected-object="selectedTour" remote-url="/api/tours/search/angucomplet?&search="
                      remote-url-data-field="items" title-field="description" description-field="price_public"
                      minlength="2" input-class="form-control" match-class="highlight">
                    </div>
                    <div class="input-group-append bg-custom b-0" ng-if="tour != null">
                      <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                        uib-tooltip="Quitar" ng-click="removeTour()">
                        <i class="fas fa-backspace w-100 f-s-12"></i>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="col-lg-12" *ngIf="validation_transport.length > 0">
              <div class="alert bg-warning m-b-10 f-s-12 alert-dismissible fade show"
                style="color: black; padding: 8px;" role="alert">
                <button type="button" class="close" aria-label="Close" (click)="validation_transport = []"
                  style="padding: 5px 10px;">
                  <span aria-hidden="true">×</span>
                </button>
                <div *ngFor="let transport of validation_transport">
                  <span class="bold">CUIDADO!</span> El transporte <span
                    class="bold">"{{transport.transport_data.fullname}}"</span>
                  ya esta asignado al grupo {{transport.code}} -> <span
                    class="bold">"{{transport.tour_data.description}}"</span> para la fecha
                  <span class="bold">{{transport.date_departure}}</span>
                </div>
              </div>
            </div>

            <div class="col-lg-12" *ngIf="validation_guide.length > 0">
              <div class="alert bg-warning m-b-10 f-s-12 alert-dismissible fade show"
                style="color: black; padding: 8px;" role="alert">
                <button type="button" class="close" aria-label="Close" (click)="validation_guide = []"
                  style="padding: 5px 10px;">
                  <span aria-hidden="true">×</span>
                </button>
                <div *ngFor="let transport of validation_guide">
                  <span class="bold">CUIDADO!</span> El guia <span
                    class="bold">"{{transport.guide_data.fullname}}"</span>
                  ya esta asignado al grupo {{transport.code}} -> <span
                    class="bold">"{{transport.tour_data.description}}"</span> para la fecha
                  <span class="bold">{{transport.date_departure}}</span>
                </div>
              </div>
            </div>

            <div class="col-lg-12 m-t-10 form__contentTbl">
              <div class="table-responsive">
                <table class="table mb-0 table-sm table-hover">
                  <thead class="thead-default">
                    <tr>
                      <th class="w-5"></th>
                      <th class="text-center">N° PAX</th>
                      <th>Vehículo</th>
                      <th>Turno</th>
                      <th class="text-center f-s-10">Etiqueta/Grupo</th>
                      <th>Responsable y Código</th>
                      <th>Hotel / Ubicacion</th>
                      <th>Teléfonos</th>
                      <th>Observaciones</th>
                      <th>Deuda</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- nueva version -->
                    <ng-container *ngIf="bookings.length == 0">
                      <tr>
                        <td colspan="7"><span><i class="m-r-5"></i>Debe seleccionar el tours para cargar los pasajeros
                            de
                            la reservas pendientes.</span>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="bookings.length > 0">
                      <ng-container *ngFor="let item of bookings; let index_ = index">
                        <tr [ngClass]="{'text-danger': isEdit && date_departure != item.date_assigned }">
                          <td class="w-5">
                            <div class="custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" id="booking_{{item.id}}"
                                (change)="selectedBooking(item)">
                              <label class="custom-control-label p-t-3" for="booking_{{item.id}}"></label>
                            </div>
                          </td>
                          <td class="text-center">
                            {{item.quantity}}
                          </td>
                          <td>
                            <span
                              class="badge f-s-10 badge-{{item.vehicle_tour_content.class}}">{{item.vehicle_tour_content.description}}</span>
                          </td>
                          <td><span class="bold">{{item.shift_tour_content.description}}</span></td>
                          <td class="text-center">
                            {{item.booking_data.reference_voucher}}
                            <div *ngIf="item.booking_data.workinggroup_id != null" style="margin-top: -4px;">
                              <span class="badge badge-dark f-s-8">{{item.booking_data.workinggroup_data.description}}</span>
                            </div>
                          </td>
                          <td>
                            {{item.booking_data.client_data.fullname}}
                            <p class="f-s-10 bold m-b-0" *ngIf="item.is_received"><span
                                class="badge badge-success">Recibido</span> | {{item.booking_data.agency_data.tradename}}</p>
                            <p class="m-b-2" ng-click="bookingDetail(item)">
                              <i *ngIf="item.booking_data.is_favorite" class="fas fa-star m-r-2 color-favorite f-s-14"></i>
                              <span class=" f-s-11 bold pointer book__code">{{item.booking_data.code}}</span>
                            </p>
                            <div class="d-inline-block" *ngIf="item.booking_data.is_reference_pax">
                              REF:
                              <span>Niños ({{item.booking_data.nro_pax_childs}})</span>,
                              <span>Adultos({{item.booking_data.nro_pax_adults}})</span>,
                              <span>Ancianos ({{item.booking_data.nro_pax_olds}})</span>
                            </div>
                          </td>
                          <td>{{item.booking_data.reference_location}}</td>
                          <td>
                            <div>{{item.booking_data.client_data.tel_1}}</div>
                            <div *ngIf="item.tel_2 != null">
                              {{item.booking_data.client_data.tel_2}}
                            </div>
                          </td>
                          <td>
                            {{item.booking_data.observations}}
                            <div *ngIf="item.observation != null">
                              | <span class="bold">{{item.observation}}</span>
                            </div>
                          </td>
                          <td>
                            <ng-container *ngIf="!item.is_received">
                              {{toolsService.momeySol()}}{{item.booking_data.total - item.booking_data.total_paid}}
                            </ng-container>
                            <ng-container *ngIf="item.is_received">
                              <ng-container *ngIf="item.is_control_total_received">
                                {{toolsService.momeySol()}}{{item.total - item.total_paid}}
                              </ng-container>
                              <ng-container *ngIf="!item.is_control_total_received">
                                {{toolsService.momeySol()}}{{item.assigned_payment}}
                              </ng-container>
                            </ng-container>
                          </td>
                        </tr>
                        <tr *ngIf="date_departure != item.date_assigned">
                          <td style="padding-top: 0px !important;" colspan="7"><span class="badge badge-danger f-s-12 w-100"><i class="fas fa-exclamation-triangle m-r-5"></i>
                              <span class="bold">ERROR CRÍTICO:</span> La reserva <strong>{{item.code}}</strong> se encuentra asignada con fecha <span
                                class="bold">{{item.date_assigned}}</span>, por lo que no puede estar asocioda a este grupo
                              (verificar en reservas)</span>
                            </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    <!-- *************** -->

                    <!-- <ng-container *ngIf="bookings.length == 0">
                      <tr>
                        <td colspan="7"><span><i class="m-r-5"></i>Debe seleccionar el tours para cargar los pasajeros
                            de
                            la reservas pendientes.</span>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="bookings.length > 0">
                      <tr *ngFor="let item of bookings; let index_ = index">
                        <td class="w-5">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="booking_{{item.id}}"
                              (change)="selectedBooking(item)">
                            <label class="custom-control-label p-t-3" for="booking_{{item.id}}"></label>
                          </div>
                        </td>
                        <td class="text-center">
                          {{item.quantity}}
                        </td>
                        <td>
                          <span
                            class="badge f-s-10 badge-{{item.vehicle_tour_content.class}}">{{item.vehicle_tour_content.description}}</span>
                        </td>
                        <td><span class="bold">{{item.shift_tour_content.description}}</span></td>
                        <td class="text-center">
                          {{item.reference_voucher}}
                          <div *ngIf="item.workinggroup_id != null" style="margin-top: -4px;">
                            <span class="badge badge-dark f-s-8">{{item.workinggroups_description}}</span>
                          </div>
                        </td>
                        <td>
                          {{item.client}}
                          <p class="f-s-10 bold m-b-0" *ngIf="item.is_received"><span
                              class="badge badge-success">Recibido</span> | {{item.agency_reponsible}}</p>
                          <p class="m-b-2" ng-click="bookingDetail(item)">
                            <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite f-s-14"></i>
                            <span class=" f-s-11 bold pointer book__code">{{item.code}}</span>
                          </p>
                          <div class="d-inline-block" *ngIf="item.is_reference_pax">
                            REF:
                            <span>Niños ({{item.nro_pax_childs}})</span>,
                            <span>Adultos({{item.nro_pax_adults}})</span>,
                            <span>Ancianos ({{item.nro_pax_olds}})</span>
                          </div>
                        </td>
                        <td>{{item.reference_location}}</td>
                        <td>
                          <div>{{item.tel_1}}</div>
                          <div *ngIf="item.tel_2 != null">
                            {{item.tel_2}}
                          </div>
                        </td>
                        <td>
                          {{item.observations}}
                          <div *ngIf="item.observation != null">
                            | <span class="bold">{{item.observation}}</span>
                          </div>
                        </td>
                        <td>
                          <ng-container *ngIf="!item.is_received">
                            {{toolsService.momeySol()}}{{item.total - item.total_paid}}
                          </ng-container>
                          <ng-container *ngIf="item.is_received">
                            {{toolsService.momeySol()}}{{item.assigned_payment}}
                          </ng-container>
                        </td>
                      </tr>
                    </ng-container> -->

                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-12">
                      <p class="m-b-5 m-t-0">
                        <i class="fas fa-star m-r-2 color-favorite f-s-14"></i> Se consideran reservas importantes
                        (Referencia de un trato especial)
                      </p>
                    </div>
                    <div class="col-lg-12 col-12">
                      <label>Observaciones</label>
                      <textarea formControlName="observations" class="form-control no-resize" rows="2"></textarea>
                    </div>
                    <!--<div class="form-group col-lg-4">-->
                    <!--<label>Viáticos</label>-->
                    <!--<div class="input-group">-->
                    <!--<div class="input-group-prepend">-->
                    <!--<div class="input-group-text">S/.</div>-->
                    <!--</div>-->
                    <!--<input type="text" class="form-control" ng-model="book.viatic_assigned">-->
                    <!--</div>-->
                    <!--</div>-->
                  </div>
                </div>
                <div class="col-lg-6 text-right">
                  <button type="button" class="btn btn-secondary m-r-5" (click)="cancel()">
                    Cancelar
                  </button>
                  <button type="button" class="btn btn-primary m-r-5" (click)="onSubmit()" *ngIf="!isEdit"
                    [disabled]="item.invalid">
                    <i class="far fa-save m-r-5"></i> GENERAR GRUPO
                  </button>
                  <button type="button" class="btn btn-success m-r-5" *ngIf="isEdit && item.value.is_confirmed == false"
                    ng-click="confirm()" [disabled]="item.invalid">
                    <i class="fas fa-check m-r-5"></i> CONFIRMAR SALIDA
                  </button>
                  <button type="button" class="btn btn-primary m-r-5" *ngIf="isEdit" (click)="onSubmit()"
                    [disabled]="item.invalid">
                    <i class="far fa-save m-r-5"></i> Guardar cambios
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-record-guide-extends></app-record-guide-extends>
<app-record-transport-extends></app-record-transport-extends>
